import { getEnvironmentFromHost } from '@ace-clublabs/log-cannon';
import SplunkOtelWeb from '@splunk/otel-web';
import { splunkRUM } from './constants';

const getAppVersionFromMeta = () => {
  return (
    document?.querySelector('meta[name="version"]')?.getAttribute('content') ||
    'unknown-version'
  );
};

const SCHEDULE_SEGMENT = /(\/schedule-appointment\/)[^/?#]+/;
const RESCHEDULE_SEGMENT = /(\/reschedule-appointment\/)[^/?#]+/;
const CANCEL_SEGMENT = /(\/cancel-appointment\/)[^/?#]+/;
const EMAIL_INQUIRY_SEGMENT = /(\/email-inquiry\/)[^/?#]+/;
const APPOINTMENT_ID_PARAM = /([?&])appointmentId=[^&#]+/;

export const normalizeRouteUrl = (url: string): string => {
  return url
    .replace(SCHEDULE_SEGMENT, '$1workTypeId')
    .replace(RESCHEDULE_SEGMENT, '$1appointmentId')
    .replace(CANCEL_SEGMENT, '$1appointmentId')
    .replace(EMAIL_INQUIRY_SEGMENT, '$1inquiryId')
    .replace(APPOINTMENT_ID_PARAM, '$1appointmentId=appointmentId');
};

if (import.meta.env.PROD && splunkRUM.SPLUNK_RUM_AUTH) {
  SplunkOtelWeb.init({
    beaconEndpoint: splunkRUM.SPLUNK_BEACON_URL,
    rumAccessToken: splunkRUM.SPLUNK_RUM_AUTH,
    applicationName: splunkRUM.SPLUNK_APP_NAME,
    version: getAppVersionFromMeta(),
    deploymentEnvironment: getEnvironmentFromHost(),
    exporter: {
      onAttributesSerializing: (attributes) => {
        const urlKeys = [
          'location.href',
          'prev.href',
          'http.url',
          'document.referrer',
        ] as const;
        let modified = false;
        const result = { ...attributes };
        for (const key of urlKeys) {
          const value = result[key];
          if (typeof value === 'string') {
            const normalized = normalizeRouteUrl(value);
            if (normalized !== value) {
              result[key] = normalized;
              modified = true;
            }
          }
        }
        return modified ? result : attributes;
      },
    },
  });
}
